module.exports = __webpack_public_path__ + "img/otf5.19434f95.png";